import {DataGrid} from '@mui/x-data-grid';
import './Home.css';
import {Link} from "react-router-dom";
import {useDepots} from "../../context/Depots/useDepots";
import moment from "moment";
import {UilEditAlt, UilExport, UilGlobe, UilPlusCircle} from "@iconscout/react-unicons";
import {ReactComponent as FlagFR} from "../../../assets/icons/fr.svg";
import {ReactComponent as FlagUE} from "../../../assets/icons/ue.svg";
import {useState} from "react";
import {Button, MenuItem, Stack, TextField} from "@mui/material";
import {generateXLSX} from "../../services/httpServices";
import {useToasts} from "react-toast-notifications";
import LogoMarque from "../../components/LogoMarque/LogoMarque";

const columns = [
    {field: 'numero', headerName: 'N° Enregistrement', flex: 0.1},
    {
        field: 'marque',
        headerName: 'Marque',
        flex: 0.2,
        renderCell: params => params.row.figurative ? <LogoMarque alt={params.value} id={params.row.id}/> : params.value
    },
    {field: 'titulaire', headerName: 'Titulaire', flex: 0.1},
    {
        field: 'dateDepot', headerName: 'Date de dépôt', flex: 0.15,
        valueGetter: params => moment(params.value),
        renderCell: params => params.value.format('DD/MM/YYYY')
    },
    {
        field: 'dateRenouvel', headerName: "Date de renouvellement", flex: 0.15,
        valueGetter: params => moment(params.value),
        renderCell: params => params.value.format("DD/MM/YYYY"),
    },
    {field: 'observations', headerName: 'Observations', flex: 0.2},
    {
        field: 'territoire',
        headerName: '',
        flex: 0.05,
        disableExport: true,
        filterable: false,
        sortName: 'Territoire (ue / fr / inter)',
        renderCell: params => {
            if (params.value === 'fr') return <FlagFR width="24px"/>
            if (params.value === 'ue') return <FlagUE width="24px"/>
            return <UilGlobe color="var(--primary)"/>
        }
    },
    {
        field: '',
        headerName: '',
        flex: 0.05,
        hideSortIcons: true,
        disableColumnMenu: true,
        disableExport: true,
        filterable: false,
        renderCell: params => (
            <Link to={`depot/${params.row.id}`} className="edit-btn" target="_blank" rel="noopener noreferrer">
                <UilEditAlt color="var(--primary)"/>
            </Link>
        )
    }
]

export default function Home() {
    const {depots} = useDepots();
    const {addToast} = useToasts()

    const [searchValue, setSearchValue] = useState("")
    const [searchField, setSearchField] = useState("marque")
    const [sortModel, setSortModel] = useState([])
    const [selection, setSelection] = useState([]);

    const getRowClassName = params => params.row.urgenceLevel

    const exportToXLSX = () => {
        if (selection && selection.length)
            generateXLSX(selection, sortModel?.[0])
                .then(res => {
                    const blob = new Blob([res.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        encoding: 'UTF-8'
                    })
                    const link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = "depots.xlsx"
                    link.click()
                    addToast("XLSX généré")
                })
    }

    const search = (e, setter) => {
        setter(e.target.value)
        setSelection([])
    }

    return (
        <div className="tableau-marques">
            <div className="add-depot-wrapper">
                <h1>Gestion des marques - Cabinet Thonnelier</h1>
                <Link className="add-depot" to="depot/new"><UilPlusCircle/> <span>Ajouter un dépôt</span></Link>
            </div>
            <Stack direction="row" justifyContent="space-between" width="100%">
                <Stack direction="row" spacing={1} width="50%">
                    <TextField onChange={e => search(e, setSearchValue)}
                               value={searchValue}
                               label="Rechercher"
                               variant="outlined" style={{width: "100%"}}/>
                    <TextField select value={searchField} onChange={e => search(e, setSearchField)}
                               label="Champ" variant="outlined" style={{width: "30%"}}>
                        {columns.filter(c => !!c.field).map(c => (
                            <MenuItem key={c.field} value={c.field}>
                                {!c.headerName ? c.sortName : c.headerName}
                            </MenuItem>
                        ))}
                    </TextField>
                </Stack>
                <Button variant="text" onClick={exportToXLSX} size="small">
                    <UilExport size={20} style={{marginRight: "5px"}}/>
                    Exporter ({selection.length})
                </Button>
            </Stack>
            <div>
                <DataGrid
                    rows={depots}
                    columns={columns}
                    checkboxSelection
                    disableSelectionOnClick
                    autoHeight
                    getRowClassName={getRowClassName}
                    onSelectionModelChange={setSelection}
                    onFilterModelChange={() => setSelection([])}
                    selectionModel={selection}
                    filterModel={{items: [{columnField: searchField, operatorValue: 'contains', value: searchValue}]}}
                    onSortModelChange={setSortModel}
                />
            </div>
        </div>
    )
}
